import { AggregationRange, FilteringState, STORE_NAME } from 'reduxStore/filtering/initialState';
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import {
  selectInitialDemographics,
  selectParentDemographic,
  toggleClassification,
} from './asyncActions';

export const filteringSlice = createSlice({
  name: STORE_NAME,
  initialState: FilteringState.INITIAL_DOMAIN,
  reducers: {
    changeAggregationPeriod: (state, action: PayloadAction<Draft<AggregationRange>>) => {
      state.aggregationPeriod = action.payload;
    },
    resetAggregationPeriod: (state) => {
      state.aggregationPeriod = FilteringState.INITIAL_AGGREGATION_PERIOD_DOMAIN;
    },
    resetSelectedClassifications: (state) => {
      state.selectedClassifications = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toggleClassification.fulfilled, (state, action) => {
      const data = action.payload;
      state.selectedClassifications = data;
    });
    builder.addCase(selectInitialDemographics.fulfilled, (state, action) => {
      const data = action.payload;
      state.selectedClassifications = data;
    });
    builder.addCase(selectParentDemographic.fulfilled, (state, action) => {
      const data = action.payload;
      state.selectedClassifications = data;
    });
  },
});

export const {
  changeAggregationPeriod,
  resetAggregationPeriod,
  resetSelectedClassifications,
} = filteringSlice.actions;
